module.exports = __webpack_public_path__ + "img/background.36317403.png";